import { GlobalLoadingProvider } from "@portal/providers/GlobalLoadingProvider";
import { ReactNode } from "react";

type MainLayoutProps = {
	mainNav: ReactNode;
	topBanner?: ReactNode;
	children: ReactNode;
};

export const MainLayout = ({ mainNav, topBanner, children }: MainLayoutProps) => {
	return (
		<div className="transition-all grid grid-cols-[60px_1fr] md:grid-cols-[225px_1fr] h-screen w-full overflow-hidden antialiased">
			{mainNav}
			<div className="flex-1 h-full flex flex-col overflow-hidden">
				{topBanner}
				<div className="flex-1 min-h-0 flex flex-col items-center relative">
					<GlobalLoadingProvider>{children}</GlobalLoadingProvider>
				</div>
			</div>
		</div>
	);
};
